import { Check } from 'lucide-react';
import { createContextSummaryPlugin } from '@tinct/web-ai';
import type { ContextSummaryContentBlock } from '@tinct/core-api-models';

export function createCampaignContextBlockPlugin(options?: {
  onConfirm?: (data: ContextSummaryContentBlock) => void;
  onStartOver?: (data: ContextSummaryContentBlock) => void;
}) {
  return createContextSummaryPlugin({
    labels: {
      goal: 'Goal',
      valueProposition: 'Value Proposition',
      targetingApproach: 'Targeting Approach',
      targetIndustries: 'Target Industries',
      targetJobTitles: 'Target Job Titles',
      targetCompanySize: 'Target Company Size',
      keyMessage: 'Key Message',
      differentiation: 'Differentiation',
      tone: 'Tone',
      keywords: 'Keywords',
    },
    actions: [
      {
        label: "Perfect, let's continue",
        icon: <Check className="size-4" />,
        onClick: (data) => options?.onConfirm?.(data),
      },
    ],
  });
}
